import axios from 'axios'

const LIST = 'list'

export default {
  getEmailTemplatesTypes (context) {
    axios.get(`${LIST}/mail/templates`).then((response) => {
      context.setEmailTemplatesTypes(response.data)
    })
  },
  getUsageTypes (context) {
    axios.get(`${LIST}/usage-types`).then((response) => {
      context.setUsageTypes(response.data)
    })
  },
  getOccupancyStatus (context) {
    axios.get(`${LIST}/occupancy-status`).then((response) => {
      context.setOccupancyStatus(response.data)
    })
  },
  getBackgroundCheckStatus (context, type) {
    axios.get(`${LIST}/status/${type}`).then((response) => {
      context.setBackgroundCheckStatus(response.data)
    })
  },
  getStatus (context, type) {
    axios.get(`${LIST}/status/${type}`).then((response) => {
      context.setStatus(response.data)
    })
  },
  getPaymentStatus (context) {
    axios.get(`${LIST}/payment-status`).then((response) => {
      context.setPaymentStatus(response.data)
    })
  },
  getContactTypes (context) {
    axios.get(`${LIST}/contact-types`).then((response) => {
      context.setContactTypes(response.data)
    })
  },
  getStates (context) {
    axios.get(`${LIST}/states`).then((response) => {
      context.setStates(response.data)
    })
  },
  getDocumentNames (context, type) {
    axios.get(`${LIST}/document-names/${type}`).then((response) => {
      context.setDocumentNames(response.data)
    })
  },
  geOrganizationTypes (context) {
    axios.get(`${LIST}/oraganization-types`).then((response) => {
      context.setOraganizationTypes(response.data)
    })
  },
  getUserTypes (context) {
    axios.get(`${LIST}/user-types`).then((response) => {
      context.setUserTypes(response.data)
    })
  },
  getPaymentTypes (context) {
    axios.get(`${LIST}/payment-types`).then((response) => {
      context.setPaymentTypes(response.data)
    })
  },
  getGenders (context) {
    axios.get(`${LIST}/genders`).then((response) => {
      context.setGenders(response.data)
    })
  },
  getOrganizations (context) {
    axios.get(`${LIST}/organizations`).then((response) => {
      context.setOrganizations(response.data)
    })
  },
  getPropertyTypes (context) {
    axios.get(`${LIST}/property-types`).then((response) => {
      context.setPropertyTypes(response.data)
    })
  },
  getPortionTypes (context) {
    axios.get(`${LIST}/portion-types`).then((response) => {
      context.setPortionTypes(response.data)
    })
  },
  getFrequencies (context) {
    axios.get(`${LIST}/frequency`).then((response) => {
      context.setFrequencies(response.data)
    })
  }
}
